import { useState, useEffect } from 'react';

/**
 * useActivityTemplates - Hook for fetching available activity templates
 * @param {string|number} childId - The child ID
 * @param {string} csrfToken - CSRF token for API calls
 * @returns {Object} Templates state and data
 */
export const useActivityTemplates = (childId, csrfToken) => {
  const [templates, setTemplates] = useState([]);
  const [familySubscription, setFamilySubscription] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Build headers - CSRF token is optional for GET requests
        const headers = {
          'Accept': 'application/json'
        };
        if (csrfToken) {
          headers['X-CSRF-Token'] = csrfToken;
        }

        const response = await fetch(`/api/children/${childId}/activity_templates`, {
          headers,
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch activity templates: ${response.statusText}`);
        }

        const data = await response.json();
        setTemplates(data.templates);
        setFamilySubscription(data.family_subscription);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    // Only require childId - csrfToken is optional for GET requests
    if (childId) {
      fetchTemplates();
    }
  }, [childId, csrfToken]);

  return { templates, familySubscription, isLoading, error };
};
